import React, {useEffect, useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {districtVillages} from "../types/interfaces";


const AlertCircle = ({ className = "w-4 h-4" }: { className?: string }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
    </svg>
);

const User = ({ className = "w-5 h-5" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
);

const Phone = ({ className = "w-5 h-5" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
    </svg>
);

const Mail = ({ className = "w-5 h-5" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
);

const MapPin = ({ className = "w-5 h-5" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
);

const Upload = ({ className = "w-5 h-5" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
    </svg>
);

const FileText = ({ className = "w-5 h-5" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
);

const ArrowUp = ({ className = "w-5 h-5" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16l3-3m0 0l3 3m-3-3v8m0-13a9 9 0 110 18 9 9 0 010-18z" />
    </svg>
);

const CheckCircle = ({ className = "w-6 h-6" }: { className?: string }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
    </svg>
);

const XCircle = ({ className = "w-6 h-6" }: { className?: string }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
    </svg>
);

const X = ({ className = "w-4 h-4" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
);

const Send = ({ className = "w-5 h-5" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
    </svg>
);

const PenTool = ({ className = "w-5 h-5" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
    </svg>
);

// Form values interface
interface FormValues {
    isExistingCustomer: string;
    // New Connection fields
    firstName: string;
    surname: string;
    nationality: string;
    gender: string;
    cellphone: string;
    contactEmail: string;
    plotNumber: string;
    postalAddress: string;
    employerDetails: string;
    alternateName: string;
    alternateSurname: string;
    alternateCellphone: string;
    alternateEmail: string;
    district: string;
    townVillage: string;
    btcService: string;
    internetSpeed: string;
    contractLength: string;
    howHeardAbout: string;
    promotionalCode: string;
    submittedBy: string;
    agreeTerms: boolean;
    declare: boolean;
    signature: string; // Add signature field
    // Service Upgrade fields
    applicationFor: string;
    physicalAddress: string;
    accountType: string;
    accountNumber: string;
    existingPackage: string;
    existingInternetSpeed: string;
    existingContractLength: string;
    newPackage: string;
    newInternetSpeed: string;
    newContractLength: string;
}

// Popup interface
interface PopupState {
    show: boolean;
    type: 'success' | 'error';
    title: string;
    message: string;
    details?: string;
}

// Validation function
const validateField = (field: keyof FormValues, value: any, isExisting: boolean): string => {
    switch (field) {
        case 'isExistingCustomer':
            return !value ? 'Please select if you are an existing customer' : '';
        case 'applicationFor':
            return isExisting && !value ? 'Please select what you are applying for' : '';
        case 'firstName':
            return !value ? 'First name is required' : '';
        case 'surname':
            return !value ? 'Surname is required' : '';
        case 'nationality':
            return !value ? 'Nationality is required' : '';
        case 'gender':
            return !value ? 'Gender is required' : '';
        case 'cellphone':
            if (!value) return 'Cellphone is required';
            if (!/^[0-9]{8}$/.test(value)) return 'Must be 8 digits';
            return '';
        case 'contactEmail':
            if (!value) return 'Contact email is required';
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Invalid email';
            return '';
        case 'plotNumber':
            return !isExisting && !value ? 'Plot number is required' : '';
        case 'employerDetails':
            return !isExisting && !value ? 'Employer details are required' : '';
        case 'alternateName':
            return !isExisting && !value ? 'Alternate contact name is required' : '';
        case 'alternateSurname':
            return !isExisting && !value ? 'Alternate contact surname is required' : '';
        case 'alternateCellphone':
            if (!isExisting && !value) return 'Alternate contact cellphone is required';
            if (!isExisting && value && !/^[0-9]{8}$/.test(value)) return 'Must be 8 digits';
            return '';
        case 'alternateEmail':
            if (!isExisting && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Invalid email';
            return '';
        case 'district':
            return !isExisting && !value ? 'District is required' : '';
        case 'townVillage':
            return !isExisting && !value ? 'Town/Village is required' : '';
        case 'btcService':
            return !isExisting && !value ? 'BTC service selection is required' : '';
        case 'internetSpeed':
            return !isExisting && !value ? 'Internet speed is required' : '';
        case 'contractLength':
            return !isExisting && !value ? 'Contract length is required' : '';
        case 'howHeardAbout':
            return !isExisting && !value ? 'How you heard about us is required' : '';
        case 'submittedBy':
            return !value ? 'Submitted by field is required' : '';
        case 'signature':
            return !value ? 'Digital signature is required' : '';
        case 'agreeTerms':
            return !value ? 'You must agree to the terms and conditions' : '';
        case 'declare':
            return !value ? 'You must declare that the information provided is true and accurate' : '';
        case 'physicalAddress':
            return isExisting && !value ? 'Physical address is required' : '';
        case 'accountType':
            return isExisting && !value ? 'Account type is required' : '';
        case 'accountNumber':
            return isExisting && !value ? 'Account number is required' : '';
        case 'existingPackage':
            return isExisting && !value ? 'Existing package is required' : '';
        case 'existingInternetSpeed':
            return isExisting && !value ? 'Existing internet speed is required' : '';
        case 'existingContractLength':
            return isExisting && !value ? 'Existing contract length is required' : '';
        case 'newPackage':
            return isExisting && !value ? 'New package is required' : '';
        case 'newInternetSpeed':
            return isExisting && !value ? 'New internet speed is required' : '';
        case 'newContractLength':
            return isExisting && !value ? 'New contract length is required' : '';
        default:
            return '';
    }
};


export default function DynamicApplicationForm() {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
    const [loggedInUser, setLoggedInUser] = useState<string>('');
    const navigate = useNavigate();

    const [selectedDistrict, setSelectedDistrict] = useState<string>("");


    // Signature canvas refs and state
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const [isDrawing, setIsDrawing] = useState(false);
    const [signatureEmpty, setSignatureEmpty] = useState(true);

    const BASE_URL = process.env.REACT_APP_API_SELFCARE_URL as string;

    const [values, setValues] = useState<FormValues>({
        isExistingCustomer: '',
        // New Connection fields
        firstName: '',
        surname: '',
        nationality: '',
        gender: '',
        cellphone: '',
        contactEmail: '',
        plotNumber: '',
        postalAddress: '',
        employerDetails: '',
        alternateName: '',
        alternateSurname: '',
        alternateCellphone: '',
        alternateEmail: '',
        district: '',
        townVillage: '',
        btcService: '',
        internetSpeed: '',
        contractLength: '',
        howHeardAbout: '',
        promotionalCode: '',
        submittedBy: '',
        agreeTerms: false,
        declare: false,
        signature: '',
        // Service Upgrade fields
        applicationFor: '',
        physicalAddress: '',
        accountType: 'Account',
        accountNumber: '',
        existingPackage: '',
        existingInternetSpeed: '',
        existingContractLength: '',
        newPackage: '',
        newInternetSpeed: '',
        newContractLength: '',
    });

    const [errors, setErrors] = useState<Record<string, string>>({});
    const [touched, setTouched] = useState<Record<string, boolean>>({});
    const [popup, setPopup] = useState<PopupState>({
        show: false,
        type: 'success',
        title: '',
        message: '',
        details: ''
    });

    const handleSelectChange = (value: string) => {
        setSelectedDistrict(value);
    };

    // @ts-ignore
    const villages :string[] = districtVillages[selectedDistrict] || [];

    // Get logged in user
    useEffect(() => {
        const userDataString = localStorage.getItem('user');
        if (userDataString) {
            try {
                const userData = JSON.parse(userDataString);
                const username = userData.username || '';
                setLoggedInUser(username);
                // Set the submittedBy field automatically
                setValues(prev => ({ ...prev, submittedBy: username }));
            } catch (error) {
                console.log('Error parsing user data:', error);
            }
        }
    }, []);

    const isExistingCustomer = values.isExistingCustomer === 'Yes';

    // Signature canvas setup
    useEffect(() => {
        const canvas = canvasRef.current;
        if (canvas) {
            const ctx = canvas.getContext('2d');
            if (ctx) {
                ctx.strokeStyle = '#000';
                ctx.lineWidth = 2;
                ctx.lineCap = 'round';
                ctx.lineJoin = 'round';
            }
        }
    }, []);

    // Helper function to get coordinates from mouse or touch event
    const getCoordinates = (e: React.MouseEvent<HTMLCanvasElement> | React.TouchEvent<HTMLCanvasElement>) => {
        const canvas = canvasRef.current;
        if (!canvas) return { x: 0, y: 0 };

        const rect = canvas.getBoundingClientRect();
        let clientX, clientY;

        if ('touches' in e) {
            // Touch event
            const touch = e.touches[0] || e.changedTouches[0];
            clientX = touch.clientX;
            clientY = touch.clientY;
        } else {
            // Mouse event
            clientX = e.clientX;
            clientY = e.clientY;
        }

        // Account for canvas scaling
        const scaleX = canvas.width / rect.width;
        const scaleY = canvas.height / rect.height;

        return {
            x: (clientX - rect.left) * scaleX,
            y: (clientY - rect.top) * scaleY
        };
    };

    const startDrawing = (e: React.MouseEvent<HTMLCanvasElement> | React.TouchEvent<HTMLCanvasElement>) => {
        e.preventDefault();
        const canvas = canvasRef.current;
        if (canvas) {
            const { x, y } = getCoordinates(e);
            const ctx = canvas.getContext('2d');
            if (ctx) {
                ctx.beginPath();
                ctx.moveTo(x, y);
                setIsDrawing(true);
            }
        }
    };

    const draw = (e: React.MouseEvent<HTMLCanvasElement> | React.TouchEvent<HTMLCanvasElement>) => {
        e.preventDefault();
        if (!isDrawing) return;

        const canvas = canvasRef.current;
        if (canvas) {
            const { x, y } = getCoordinates(e);
            const ctx = canvas.getContext('2d');
            if (ctx) {
                ctx.lineTo(x, y);
                ctx.stroke();
                setSignatureEmpty(false);
            }
        }
    };

    const stopDrawing = () => {
        setIsDrawing(false);
        saveSignature();
    };

    const saveSignature = () => {
        const canvas = canvasRef.current;
        if (canvas) {
            const dataURL = canvas.toDataURL('image/png');
            setValues(prev => ({ ...prev, signature: dataURL }));

            // Clear signature error when signature is created
            if (errors.signature) {
                setErrors(prev => ({ ...prev, signature: '' }));
            }
        }
    };

    const clearSignature = () => {
        const canvas = canvasRef.current;
        if (canvas) {
            const ctx = canvas.getContext('2d');
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                setSignatureEmpty(true);
                setValues(prev => ({ ...prev, signature: '' }));
            }
        }
    };

    const handleChange = (field: keyof FormValues) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {

        const value:any = e.target.type === 'checkbox' ? (e.target as HTMLInputElement).checked : e.target.value;
        setValues(prev => ({ ...prev, [field]: value }));

        if (field === 'district') handleSelectChange(value)

        // Clear error when user starts typing
        if (errors[field]) {
            setErrors(prev => ({ ...prev, [field]: '' }));
        }

        // Reset form when customer type changes
        if (field === 'isExistingCustomer') {
            setErrors({});
            setTouched({});
            clearSignature(); // Clear signature when switching forms
            setValues(prev => ({
                isExistingCustomer: value as string,
                firstName: '',
                surname: '',
                nationality: '',
                gender: '',
                cellphone: '',
                contactEmail: '',
                plotNumber: '',
                postalAddress: '',
                employerDetails: '',
                alternateName: '',
                alternateSurname: '',
                alternateCellphone: '',
                alternateEmail: '',
                district: '',
                townVillage: '',
                btcService: '',
                internetSpeed: '',
                contractLength: '',
                howHeardAbout: '',
                promotionalCode: '',
                submittedBy: loggedInUser,
                agreeTerms: false,
                declare: false,
                signature: '',
                applicationFor: '',
                physicalAddress: '',
                accountType: 'Account',
                accountNumber: '',
                existingPackage: '',
                existingInternetSpeed: '',
                existingContractLength: '',
                newPackage: '',
                newInternetSpeed: '',
                newContractLength: '',
            }));
        }
    };

    const handleBlur = (field: keyof FormValues) => () => {
        setTouched(prev => ({ ...prev, [field]: true }));
        const error = validateField(field, values[field], isExistingCustomer);
        setErrors(prev => ({ ...prev, [field]: error }));
    };

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = Array.from(event.target.files || []);
        setUploadedFiles(prev => [...prev, ...files]);
    };

    const removeFile = (index: number) => {
        setUploadedFiles(prev => prev.filter((_, i) => i !== index));
    };

    const clearForm = () => {
        setValues({
            isExistingCustomer: '',
            firstName: '',
            surname: '',
            nationality: '',
            gender: '',
            cellphone: '',
            contactEmail: '',
            plotNumber: '',
            postalAddress: '',
            employerDetails: '',
            alternateName: '',
            alternateSurname: '',
            alternateCellphone: '',
            alternateEmail: '',
            district: '',
            townVillage: '',
            btcService: '',
            internetSpeed: '',
            contractLength: '',
            howHeardAbout: '',
            promotionalCode: '',
            submittedBy: loggedInUser,
            agreeTerms: false,
            declare: false,
            signature: '',
            applicationFor: '',
            physicalAddress: '',
            accountType: 'Account',
            accountNumber: '',
            existingPackage: '',
            existingInternetSpeed: '',
            existingContractLength: '',
            newPackage: '',
            newInternetSpeed: '',
            newContractLength: '',
        });
        setUploadedFiles([]);
        setErrors({});
        setTouched({});
        clearSignature();
    };

    const closePopup = () => {
        setPopup(prev => ({ ...prev, show: false }));
    };

    // Email sending function
    const sendApplicationEmail = async (formData: FormValues, files: File[]) => {
        try {
            console.log('Sending application email...');
            console.log('Form data:', formData);
            console.log('Files to send:', files.length);

            // Create FormData object to handle files
            const formDataToSend = new FormData();

            // Add form data as JSON string
            formDataToSend.append('formData', JSON.stringify(formData));

            // Add each file
            files.forEach((file, index) => {
                formDataToSend.append('files', file);
                console.log(`📎 Adding file ${index + 1}: ${file.name} (${(file.size / 1024).toFixed(2)} KB)`);
            });

            // Convert signature to blob and add as file if exists
            if (formData.signature) {
                const response = await fetch(formData.signature);
                const blob = await response.blob();
                const signatureFile = new File([blob], 'signature.png', { type: 'image/png' });
                formDataToSend.append('files', signatureFile);
                console.log('Adding signature as file');
            }

            console.log('Sending FormData with', files.length + (formData.signature ? 1 : 0), 'files');

            // Send FormData (no Content-Type header needed - browser will set it automatically)
            const response = await fetch(BASE_URL+'/home/send-application-email', {
                method: 'POST',
                body: formDataToSend,
            });

            const result = await response.json();
            console.log('Email response:', result);

            if (!response.ok) {
                throw new Error(result.detail || result.error || 'Failed to send email');
            }

            return result;
        } catch (error) {
            console.error('Email sending error:', error);
            throw error;
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        // Validate all relevant fields based on customer type
        const newErrors: Record<string, string> = {};
        (Object.keys(values) as Array<keyof FormValues>).forEach(field => {
            const error = validateField(field, values[field], isExistingCustomer);
            if (error) newErrors[field] = error;
        });

        setErrors(newErrors);
        setTouched((Object.keys(values) as Array<keyof FormValues>).reduce((acc, key) => ({ ...acc, [key]: true }), {}));

        if (Object.keys(newErrors).some(key => newErrors[key])) {
            setPopup({
                show: true,
                type: 'error',
                title: 'Validation Error',
                message: 'Please correct the errors in the form before submitting.',
                details: ''
            });
            return;
        }

        try {
            setIsSubmitting(true);
            console.log('Submitting application...');
            console.log('Form values:', values);
            console.log('Uploaded files:', uploadedFiles);

            // Send email
            const emailResult = await sendApplicationEmail(values, uploadedFiles);
            console.log('Email sent successfully:', emailResult);

            const formType = isExistingCustomer ? 'Service Upgrade' : 'New Connection';
            setPopup({
                show: true,
                type: 'success',
                title: `${formType} Request Submitted Successfully!`,
                message: `Your ${formType.toLowerCase()} request has been submitted and sent.`,
                details: `Email sent!\n Copy sent to: ${values.contactEmail}\n Message ID: ${emailResult.messageId || 'N/A'}\nSignature included: ${values.signature ? 'Yes' : 'No'}\n\nOur team will contact you within 2-3 business days to proceed with your application.`
            });

            // Clear form on successful submission
            clearForm();

        } catch (error: any) {
            console.error('Submission error:', error);
            setPopup({
                show: true,
                type: 'error',
                title: 'Submission Failed',
                message: 'There was an error sending your application email.',
                details: `Error: ${error.message}\n\nPlease try again or contact support if the problem persists.`
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 py-8 px-4">
            {/* Popup Modal */}
            {popup.show && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                    <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 relative">
                        <button
                            onClick={closePopup}
                            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
                        >
                            <X className="w-5 h-5" />
                        </button>

                        <div className="text-center">
                            {popup.type === 'success' ? (
                                <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
                            ) : (
                                <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
                            )}

                            <h3 className={`text-xl font-bold mb-2 ${popup.type === 'success' ? 'text-green-700' : 'text-red-700'}`}>
                                {popup.title}
                            </h3>

                            <p className="text-gray-600 mb-4">{popup.message}</p>

                            {popup.details && (
                                <div className="bg-gray-50 rounded-lg p-3 mb-4 text-left">
                                    <pre className="text-sm text-gray-700 whitespace-pre-wrap">{popup.details}</pre>
                                </div>
                            )}

                            <button
                                onClick={closePopup}
                                className={`w-full py-3 px-6 rounded-lg font-semibold text-white transition-colors ${
                                    popup.type === 'success'
                                        ? 'bg-green-600 hover:bg-green-700'
                                        : 'bg-red-600 hover:bg-red-700'
                                }`}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className="max-w-4xl mx-auto">
                <div className="bg-white rounded-2xl shadow-xl p-8">
                    {/* Dynamic Header */}
                    <div className="text-center mb-8">
                        {/* Back button */}
                        <div className="flex items-center justify-between mb-4">
                            <button
                                type="button"
                                onClick={() => navigate(-1)}
                                className="flex items-center text-gray-600 hover:text-green-700 transition-colors duration-200 group"
                            >
                                <svg className="w-5 h-5 mr-2 transform group-hover:-translate-x-1 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                                </svg>
                                Back
                            </button>
                            <div></div> {/* Spacer for centering the title */}
                        </div>

                        {values.isExistingCustomer === '' ? (
                            <>
                                <FileText className="w-12 h-12 text-green-700 mx-auto mb-4" />
                                <h1 className="text-3xl font-bold text-green-700 mb-2">BTC Service Application</h1>
                                <p className="text-gray-600">Please select your customer status to continue</p>
                            </>
                        ) : isExistingCustomer ? (
                            <>
                                <ArrowUp className="w-12 h-12 text-green-700 mx-auto mb-4" />
                                <h1 className="text-3xl font-bold text-green-700 mb-2">Service Upgrade Request</h1>
                                <p className="text-gray-600">Submit your service upgrade application</p>
                            </>
                        ) : (
                            <>
                                <FileText className="w-12 h-12 text-green-700 mx-auto mb-4" />
                                <h1 className="text-3xl font-bold text-green-700 mb-2">New Connection Request</h1>
                                <p className="text-gray-600">Submit your service application</p>
                            </>
                        )}
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-6">
                        {/* Existing Customer Section */}
                        <div className="border-b pb-6">
                            <div>
                                <label className="block text-sm font-medium text-green-700 mb-2">Are you an existing BTC customer? *</label>
                                <select
                                    value={values.isExistingCustomer}
                                    onChange={handleChange('isExistingCustomer')}
                                    onBlur={handleBlur('isExistingCustomer')}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                >
                                    <option value="">Please Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                                {touched.isExistingCustomer && errors.isExistingCustomer && (
                                    <p className="text-red-500 text-sm mt-1 flex items-center">
                                        <AlertCircle className="w-4 h-4" />
                                        <span className="ml-1">{errors.isExistingCustomer}</span>
                                    </p>
                                )}
                            </div>
                        </div>

                        {/* Service Upgrade Form */}
                        {isExistingCustomer && (
                            <>
                                <div className="border-b pb-6">
                                    <div>
                                        <label className="block text-sm font-medium text-green-700 mb-2">What are you applying for? *</label>
                                        <select
                                            value={values.applicationFor}
                                            onChange={handleChange('applicationFor')}
                                            onBlur={handleBlur('applicationFor')}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                        >
                                            <option value="">Please Select</option>
                                            <option value="Upgrade of existing BTC service">Upgrade of existing BTC service</option>
                                        </select>
                                        {touched.applicationFor && errors.applicationFor && (
                                            <p className="text-red-500 text-sm mt-1 flex items-center">
                                                <AlertCircle className="w-4 h-4" />
                                                <span className="ml-1">{errors.applicationFor}</span>
                                            </p>
                                        )}
                                    </div>
                                </div>

                                {/* Personal Details Section for Upgrade */}
                                <div className="border-b pb-6">
                                    <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                                        <User className="w-5 h-5" />
                                        <span className="ml-2">Personal Details</span>
                                    </h2>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">First Name *</label>
                                            <input
                                                type="text"
                                                value={values.firstName}
                                                onChange={handleChange('firstName')}
                                                onBlur={handleBlur('firstName')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            />
                                            {touched.firstName && errors.firstName && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.firstName}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Surname *</label>
                                            <input
                                                type="text"
                                                value={values.surname}
                                                onChange={handleChange('surname')}
                                                onBlur={handleBlur('surname')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            />
                                            {touched.surname && errors.surname && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.surname}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Nationality *</label>
                                            <input
                                                type="text"
                                                value={values.nationality}
                                                onChange={handleChange('nationality')}
                                                onBlur={handleBlur('nationality')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            />
                                            {touched.nationality && errors.nationality && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.nationality}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Gender *</label>
                                            <select
                                                value={values.gender}
                                                onChange={handleChange('gender')}
                                                onBlur={handleBlur('gender')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            >
                                                <option value="">Please Select</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                            </select>
                                            {touched.gender && errors.gender && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.gender}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Cellphone *</label>
                                            <input
                                                type="tel"
                                                maxLength={8}
                                                value={values.cellphone}
                                                onChange={handleChange('cellphone')}
                                                onBlur={handleBlur('cellphone')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                                placeholder="7*******"
                                            />
                                            {touched.cellphone && errors.cellphone && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.cellphone}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Contact Email *</label>
                                            <input
                                                type="email"
                                                value={values.contactEmail}
                                                onChange={handleChange('contactEmail')}
                                                onBlur={handleBlur('contactEmail')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                                placeholder="example@email.com"
                                            />
                                            {touched.contactEmail && errors.contactEmail && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.contactEmail}</span>
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    <div className="mt-4">
                                        <label className="block text-sm font-medium text-green-700 mb-2">Physical Address *</label>
                                        <textarea
                                            value={values.physicalAddress}
                                            onChange={handleChange('physicalAddress')}
                                            onBlur={handleBlur('physicalAddress')}
                                            rows={3}
                                            maxLength={250}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
                                            placeholder="0 / 250 (Max: character length)"
                                        />
                                        {touched.physicalAddress && errors.physicalAddress && (
                                            <p className="text-red-500 text-sm mt-1 flex items-center">
                                                <AlertCircle className="w-4 h-4" />
                                                <span className="ml-1">{errors.physicalAddress}</span>
                                            </p>
                                        )}
                                    </div>

                                    <div className="mt-4">
                                        <label className="block text-sm font-medium text-green-700 mb-2">Submitted By *</label>
                                        <input
                                            type="text"
                                            value={values.submittedBy}
                                            onChange={handleChange('submittedBy')}
                                            onBlur={handleBlur('submittedBy')}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-gray-100"
                                            placeholder="Logged in user"
                                            readOnly
                                        />
                                        {touched.submittedBy && errors.submittedBy && (
                                            <p className="text-red-500 text-sm mt-1 flex items-center">
                                                <AlertCircle className="w-4 h-4" />
                                                <span className="ml-1">{errors.submittedBy}</span>
                                            </p>
                                        )}
                                    </div>
                                </div>

                                {/* Account Details Section */}
                                <div className="border-b pb-6">
                                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Specify existing account details</h2>

                                    <div className="flex items-center space-x-4 mb-4">
                                        <label className="flex items-center space-x-2">
                                            <input
                                                type="radio"
                                                name="accountType"
                                                value="Account"
                                                checked={values.accountType === 'Account'}
                                                onChange={handleChange('accountType')}
                                                className="w-4 h-4 text-green-600"
                                            />
                                            <span className="text-gray-700">Account</span>
                                        </label>
                                        <label className="flex items-center space-x-2">
                                            <input
                                                type="radio"
                                                name="accountType"
                                                value="Telephone"
                                                checked={values.accountType === 'Telephone'}
                                                onChange={handleChange('accountType')}
                                                className="w-4 h-4 text-green-600"
                                            />
                                            <span className="text-gray-700">Telephone</span>
                                        </label>
                                    </div>

                                    <div className="mb-4">
                                        <label className="block text-sm font-medium text-green-700 mb-2">Account Number *</label>
                                        <input
                                            type="text"
                                            value={values.accountNumber}
                                            onChange={handleChange('accountNumber')}
                                            onBlur={handleBlur('accountNumber')}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                        />
                                        {touched.accountNumber && errors.accountNumber && (
                                            <p className="text-red-500 text-sm mt-1 flex items-center">
                                                <AlertCircle className="w-4 h-4" />
                                                <span className="ml-1">{errors.accountNumber}</span>
                                            </p>
                                        )}
                                    </div>

                                    <div className="mb-4">
                                        <label className="block text-sm font-medium text-green-700 mb-2">Existing Package *</label>
                                        <select
                                            value={values.existingPackage}
                                            onChange={handleChange('existingPackage')}
                                            onBlur={handleBlur('existingPackage')}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                        >
                                            <option value="">Please Select</option>
                                            <option value="Home Internet Application">Home Internet Application</option>
                                            <option value="Home Internet Application(with Voice)">Home Internet Application(with Voice)</option>
                                            <option value="Mobile Internet Application">Mobile Internet Application</option>
                                            <option value="Home & Mobile Internet Application">Home & Mobile Internet Application</option>
                                            <option value="ProConnect (Postpaid Sim Only )">ProConnect (Postpaid Sim Only )</option>
                                            <option value="ProConnect (incl device)">ProConnect (incl device)</option>
                                            <option value="ProData Packages Application">ProData Packages Application</option>
                                            <option value="Hosting & Domain application">Hosting & Domain application</option>
                                            <option value="Fixed Line Application">Fixed Line Application</option>
                                        </select>
                                        {touched.existingPackage && errors.existingPackage && (
                                            <p className="text-red-500 text-sm mt-1 flex items-center">
                                                <AlertCircle className="w-4 h-4" />
                                                <span className="ml-1">{errors.existingPackage}</span>
                                            </p>
                                        )}
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Internet speed *</label>
                                            <select
                                                value={values.existingInternetSpeed}
                                                onChange={handleChange('existingInternetSpeed')}
                                                onBlur={handleBlur('existingInternetSpeed')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            >
                                                <option value="">Please Select</option>
                                                <option value="100 Mbps">100 Mbps</option>
                                                <option value="150 Mbps">150 Mbps</option>
                                                <option value="250 Mbps">250 Mbps</option>
                                                <option value="300 Mbps">300 Mbps</option>
                                            </select>
                                            {touched.existingInternetSpeed && errors.existingInternetSpeed && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.existingInternetSpeed}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Contract length *</label>
                                            <select
                                                value={values.existingContractLength}
                                                onChange={handleChange('existingContractLength')}
                                                onBlur={handleBlur('existingContractLength')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            >
                                                <option value="">Please Select</option>
                                                <option value="12 months">12 months</option>
                                                <option value="24 months">24 months</option>
                                            </select>
                                            {touched.existingContractLength && errors.existingContractLength && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.existingContractLength}</span>
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* New Package Section */}
                                <div className="border-b pb-6">
                                    <h2 className="text-xl font-semibold text-gray-800 mb-4">New Required Package or Value Added Service</h2>

                                    <div className="mb-4">
                                        <label className="block text-sm font-medium text-green-700 mb-2">New Required Package or Value Added Service *</label>
                                        <select
                                            value={values.newPackage}
                                            onChange={handleChange('newPackage')}
                                            onBlur={handleBlur('newPackage')}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                        >
                                            <option value="">Please Select</option>
                                            <option value="Home Internet Application">Home Internet Application</option>
                                            <option value="Home Internet Application(with Voice)">Home Internet Application(with Voice)</option>
                                            <option value="Mobile Internet Application">Mobile Internet Application</option>
                                            <option value="Home & Mobile Internet Application">Home & Mobile Internet Application</option>
                                            <option value="ProConnect (Postpaid Sim Only )">ProConnect (Postpaid Sim Only )</option>
                                            <option value="ProConnect (incl device)">ProConnect (incl device)</option>
                                            <option value="ProData Packages Application">ProData Packages Application</option>
                                            <option value="Hosting & Domain application">Hosting & Domain application</option>
                                            <option value="Fixed Line Application">Fixed Line Application</option>
                                        </select>
                                        {touched.newPackage && errors.newPackage && (
                                            <p className="text-red-500 text-sm mt-1 flex items-center">
                                                <AlertCircle className="w-4 h-4" />
                                                <span className="ml-1">{errors.newPackage}</span>
                                            </p>
                                        )}
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Internet speed *</label>
                                            <select
                                                value={values.newInternetSpeed}
                                                onChange={handleChange('newInternetSpeed')}
                                                onBlur={handleBlur('newInternetSpeed')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            >
                                                <option value="">Please Select</option>
                                                <option value="100 Mbps">100 Mbps</option>
                                                <option value="150 Mbps">150 Mbps</option>
                                                <option value="200 Mbps">200 Mbps</option>
                                                <option value="300 Mbps">300 Mbps</option>
                                            </select>
                                            {touched.newInternetSpeed && errors.newInternetSpeed && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.newInternetSpeed}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Contract length *</label>
                                            <select
                                                value={values.newContractLength}
                                                onChange={handleChange('newContractLength')}
                                                onBlur={handleBlur('newContractLength')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            >
                                                <option value="">Please Select</option>
                                                <option value="12 months">12 months</option>
                                                <option value="24 months">24 months</option>
                                            </select>
                                            {touched.newContractLength && errors.newContractLength && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.newContractLength}</span>
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        {/* New Connection Form */}
                        {!isExistingCustomer && values.isExistingCustomer && (
                            <>
                                {/* Personal Details Section */}
                                <div className="border-b pb-6">
                                    <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                                        <User className="w-5 h-5" />
                                        <span className="ml-2">Personal Details</span>
                                    </h2>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">First Name *</label>
                                            <input
                                                type="text"
                                                value={values.firstName}
                                                onChange={handleChange('firstName')}
                                                onBlur={handleBlur('firstName')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            />
                                            {touched.firstName && errors.firstName && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.firstName}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Surname *</label>
                                            <input
                                                type="text"
                                                value={values.surname}
                                                onChange={handleChange('surname')}
                                                onBlur={handleBlur('surname')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            />
                                            {touched.surname && errors.surname && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.surname}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Nationality *</label>
                                            <input
                                                type="text"
                                                value={values.nationality}
                                                onChange={handleChange('nationality')}
                                                onBlur={handleBlur('nationality')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            />
                                            {touched.nationality && errors.nationality && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.nationality}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Gender *</label>
                                            <select
                                                value={values.gender}
                                                onChange={handleChange('gender')}
                                                onBlur={handleBlur('gender')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            >
                                                <option value="">Please Select</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                            </select>
                                            {touched.gender && errors.gender && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.gender}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Cellphone *</label>
                                            <input
                                                type="tel"
                                                maxLength={8}
                                                value={values.cellphone}
                                                onChange={handleChange('cellphone')}
                                                onBlur={handleBlur('cellphone')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                                placeholder="7*******"
                                            />
                                            {touched.cellphone && errors.cellphone && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.cellphone}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Contact Email *</label>
                                            <input
                                                type="email"
                                                value={values.contactEmail}
                                                onChange={handleChange('contactEmail')}
                                                onBlur={handleBlur('contactEmail')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                                placeholder="example@email.com"
                                            />
                                            {touched.contactEmail && errors.contactEmail && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.contactEmail}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Plot Number *</label>
                                            <textarea
                                                value={values.plotNumber}
                                                onChange={handleChange('plotNumber')}
                                                onBlur={handleBlur('plotNumber')}
                                                rows={3}
                                                maxLength={250}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
                                                placeholder="0 / 250 (Max: character length)"
                                            />
                                            {touched.plotNumber && errors.plotNumber && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.plotNumber}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Postal Address</label>
                                            <input
                                                type="text"
                                                value={values.postalAddress}
                                                onChange={handleChange('postalAddress')}
                                                onBlur={handleBlur('postalAddress')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            />
                                        </div>
                                    </div>

                                    <div className="mt-4">
                                        <label className="block text-sm font-medium text-green-700 mb-2">Employer's Details *</label>
                                        <textarea
                                            value={values.employerDetails}
                                            onChange={handleChange('employerDetails')}
                                            onBlur={handleBlur('employerDetails')}
                                            rows={4}
                                            maxLength={250}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
                                            placeholder="0 / 250 (Max: character length)"
                                        />
                                        {touched.employerDetails && errors.employerDetails && (
                                            <p className="text-red-500 text-sm mt-1 flex items-center">
                                                <AlertCircle className="w-4 h-4" />
                                                <span className="ml-1">{errors.employerDetails}</span>
                                            </p>
                                        )}
                                    </div>
                                </div>

                                {/* Alternate Contact Section */}
                                <div className="border-b pb-6">
                                    <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                                        <Phone className="w-5 h-5" />
                                        <span className="ml-2">Alternate Contact</span>
                                    </h2>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Name *</label>
                                            <input
                                                type="text"
                                                value={values.alternateName}
                                                onChange={handleChange('alternateName')}
                                                onBlur={handleBlur('alternateName')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            />
                                            {touched.alternateName && errors.alternateName && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.alternateName}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Surname *</label>
                                            <input
                                                type="text"
                                                value={values.alternateSurname}
                                                onChange={handleChange('alternateSurname')}
                                                onBlur={handleBlur('alternateSurname')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            />
                                            {touched.alternateSurname && errors.alternateSurname && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.alternateSurname}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Cellphone *</label>
                                            <input
                                                type="tel"
                                                maxLength={8}
                                                value={values.alternateCellphone}
                                                onChange={handleChange('alternateCellphone')}
                                                onBlur={handleBlur('alternateCellphone')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                                placeholder="7*******"
                                            />
                                            {touched.alternateCellphone && errors.alternateCellphone && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.alternateCellphone}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Email Address</label>
                                            <input
                                                type="email"
                                                value={values.alternateEmail}
                                                onChange={handleChange('alternateEmail')}
                                                onBlur={handleBlur('alternateEmail')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                                placeholder="example@email.com"
                                            />
                                            {touched.alternateEmail && errors.alternateEmail && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.alternateEmail}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">District *</label>
                                            <select
                                                value={values.district}
                                                onChange={handleChange('district')}
                                                onBlur={handleBlur('district')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            >

                                                <option value="">-- Select District --</option>
                                                {Object.keys(districtVillages).map((district) => (
                                                    <option key={district} value={district}>
                                                        {district}
                                                    </option>
                                                ))}
                                            </select>
                                            {touched.district && errors.district && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.district}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Villages *</label>
                                            <select
                                                value={values.townVillage}
                                                onChange={handleChange('townVillage')}
                                                onBlur={handleBlur('townVillage')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            >
                                                <option value="">-- Select Village --</option>
                                                {villages.map((village:any) => (
                                                    <option key={village} value={village}>
                                                        {village}
                                                    </option>
                                                ))}
                                            </select>
                                            {touched.townVillage && errors.townVillage && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                </p>
                                            )}
                                        </div>


                                    </div>
                                </div>

                                {/* Service Selection Section */}
                                <div className="border-b pb-6">
                                    <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                                        <MapPin className="w-5 h-5" />
                                        <span className="ml-2">Service Selection</span>
                                    </h2>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Country *</label>
                                            <div className="flex items-center space-x-2 px-4 py-3 border border-gray-300 rounded-lg bg-gray-50">
                                                <input type="checkbox" checked readOnly className="w-4 h-4" />
                                                <span className="text-gray-700">Botswana</span>
                                            </div>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Choose the BTC service you are applying for *</label>
                                            <select
                                                value={values.btcService}
                                                onChange={handleChange('btcService')}
                                                onBlur={handleBlur('btcService')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            >
                                                <option value="">Please Select</option>
                                                <option value="Home Internet Application">Home Internet Application</option>
                                                <option value="Home Internet Application(with Voice)">Home Internet Application(with Voice)</option>
                                                <option value="Mobile Internet Application">Mobile Internet Application</option>
                                                <option value="Home & Mobile Internet Application">Home & Mobile Internet Application</option>
                                                <option value="ProConnect (Postpaid Sim Only )">ProConnect (Postpaid Sim Only )</option>
                                                <option value="ProConnect (incl device)">ProConnect (incl device)</option>
                                                <option value="ProData Packages Application">ProData Packages Application</option>
                                                <option value="Hosting & Domain application">Hosting & Domain application</option>
                                                <option value="Fixed Line Application">Fixed Line Application</option>
                                            </select>
                                            {touched.btcService && errors.btcService && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.btcService}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Internet Speed *</label>
                                            <select
                                                value={values.internetSpeed}
                                                onChange={handleChange('internetSpeed')}
                                                onBlur={handleBlur('internetSpeed')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            >
                                                <option value="">Please Select</option>
                                                <option value="100 Mbps">100 Mbps</option>
                                                <option value="150 Mbps">150 Mbps</option>
                                                <option value="200 Mbps">200 Mbps</option>
                                                <option value="300 Mbps">300 Mbps</option>
                                            </select>
                                            {touched.internetSpeed && errors.internetSpeed && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.internetSpeed}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Contract Length *</label>
                                            <select
                                                value={values.contractLength}
                                                onChange={handleChange('contractLength')}
                                                onBlur={handleBlur('contractLength')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            >
                                                <option value="">Please Select</option>
                                                <option value="12 months">12 months</option>
                                                <option value="24 months">24 months</option>
                                            </select>
                                            {touched.contractLength && errors.contractLength && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.contractLength}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">How did you hear about this? *</label>
                                            <select
                                                value={values.howHeardAbout}
                                                onChange={handleChange('howHeardAbout')}
                                                onBlur={handleBlur('howHeardAbout')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            >
                                                <option value="">Please Select</option>
                                                <option value="field agent">field agent</option>
                                                <option value="facebook">facebook</option>
                                                <option value="twitter">twitter</option>
                                                <option value="linkedIn">linkedIn</option>
                                            </select>
                                            {touched.howHeardAbout && errors.howHeardAbout && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center">
                                                    <AlertCircle className="w-4 h-4" />
                                                    <span className="ml-1">{errors.howHeardAbout}</span>
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-green-700 mb-2">Promotional Code</label>
                                            <input
                                                type="text"
                                                value={values.promotionalCode}
                                                onChange={handleChange('promotionalCode')}
                                                onBlur={handleBlur('promotionalCode')}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                                placeholder="Enter promotional code if any"
                                            />
                                        </div>
                                    </div>

                                    <div className="mt-4">
                                        <label className="block text-sm font-medium text-green-700 mb-2">Submitted By *</label>
                                        <input
                                            type="text"
                                            value={values.submittedBy}
                                            onChange={handleChange('submittedBy')}
                                            onBlur={handleBlur('submittedBy')}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-gray-100"
                                            placeholder="Logged in user"
                                            readOnly
                                        />
                                        {touched.submittedBy && errors.submittedBy && (
                                            <p className="text-red-500 text-sm mt-1 flex items-center">
                                                <AlertCircle className="w-4 h-4" />
                                                <span className="ml-1">{errors.submittedBy}</span>
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}

                        {/* File Upload Section - Show for both forms */}
                        {values.isExistingCustomer && (
                            <div className="border-b pb-6">
                                <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                                    <Upload className="w-5 h-5" />
                                    <span className="ml-2">File Upload</span>
                                </h2>

                                <div className="space-y-4">
                                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-green-500 transition-colors">
                                        <Upload className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                                        <label className="cursor-pointer">
                                            <span className="bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 transition-colors">
                                                Upload Files
                                            </span>
                                            <input
                                                type="file"
                                                multiple
                                                onChange={handleFileUpload}
                                                className="hidden"
                                                accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                                            />
                                        </label>
                                        <p className="text-gray-500 text-sm mt-2">or drag and drop files here</p>
                                    </div>

                                    <div className="text-sm text-gray-600 space-y-1">
                                        <p>• Proof of identification: Copy of ID/passport (including valid work permit, residence permit)</p>
                                        <p>• Copy of your most recent payslip and three months' bank statements</p>
                                        <p>• Accepted formats: PDF, JPG, JPEG, PNG, DOC, DOCX</p>
                                    </div>

                                    {uploadedFiles.length > 0 && (
                                        <div className="space-y-2">
                                            <h4 className="font-medium text-gray-700">Uploaded Files:</h4>
                                            {uploadedFiles.map((file, index) => (
                                                <div key={index} className="flex items-center justify-between bg-gray-50 p-3 rounded-lg">
                                                    <span className="text-sm text-gray-700">{file.name}</span>
                                                    <button
                                                        type="button"
                                                        onClick={() => removeFile(index)}
                                                        className="text-red-500 hover:text-red-700 text-sm font-medium"
                                                    >
                                                        Remove
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Digital Signature Section - Show for both forms */}
                        {values.isExistingCustomer && (
                            <div className="border-b pb-6">
                                <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                                    <PenTool className="w-5 h-5" />
                                    <span className="ml-2">Digital Signature</span>
                                </h2>

                                <div className="space-y-4">
                                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                                        <p className="text-sm text-blue-800">
                                            <strong>Please sign below:</strong> Your digital signature confirms that all information provided is accurate and complete.
                                        </p>
                                    </div>

                                    <div className="border-2 border-gray-300 rounded-lg p-4 bg-white">
                                        <label className="block text-sm font-medium text-green-700 mb-2">
                                            Digital Signature *
                                        </label>

                                        <div className="relative">
                                            <canvas
                                                ref={canvasRef}
                                                width={600}
                                                height={200}
                                                onMouseDown={startDrawing}
                                                onMouseMove={draw}
                                                onMouseUp={stopDrawing}
                                                onMouseLeave={stopDrawing}
                                                onTouchStart={startDrawing}
                                                onTouchMove={draw}
                                                onTouchEnd={stopDrawing}
                                                className="border-2 border-dashed border-gray-300 rounded-lg cursor-crosshair bg-white"
                                                style={{
                                                    touchAction: 'none',
                                                    width: '100%',
                                                    height: '200px'
                                                }}
                                            />

                                            {signatureEmpty && (
                                                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                                                    <p className="text-gray-400 text-sm">Click and drag to sign here</p>
                                                </div>
                                            )}
                                        </div>

                                        <div className="flex justify-between items-center mt-3">
                                            <button
                                                type="button"
                                                onClick={clearSignature}
                                                className="text-sm bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg transition-colors"
                                            >
                                                Clear Signature
                                            </button>

                                            <div className="flex items-center space-x-2">
                                                {!signatureEmpty && (
                                                    <span className="text-sm text-green-600 font-medium">✓ Signature captured</span>
                                                )}
                                            </div>
                                        </div>

                                        {touched.signature && errors.signature && (
                                            <p className="text-red-500 text-sm mt-2 flex items-center">
                                                <AlertCircle className="w-4 h-4" />
                                                <span className="ml-1">{errors.signature}</span>
                                            </p>
                                        )}
                                    </div>

                                    <div className="text-sm text-gray-600 space-y-1">
                                        <p>• Your signature will be included with your application</p>
                                        <p>• By signing, you confirm all information is accurate and complete</p>
                                        <p>• Use a mouse or touch device for best results</p>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Terms and Conditions Section - Show for both forms */}
                        {values.isExistingCustomer && (
                            <div className="border-b pb-6">
                                <h2 className="text-xl font-semibold text-gray-800 mb-4">Terms and Conditions</h2>

                                <div className="space-y-4">
                                    <div className="flex items-start space-x-3">
                                        <input
                                            type="checkbox"
                                            id="agreeTerms"
                                            checked={values.agreeTerms}
                                            onChange={handleChange('agreeTerms')}
                                            onBlur={handleBlur('agreeTerms')}
                                            className="mt-1 w-4 h-4 text-green-600 border-gray-300 rounded focus:ring-green-500"
                                        />
                                        <label htmlFor="agreeTerms" className="text-sm text-gray-700">
                                            I agree to the{' '}
                                            <a
                                                href="https://btc.bw/terms-conditions-for-online-portal/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-green-600 hover:text-green-800 underline font-medium"
                                            >
                                                Terms and Conditions
                                            </a>{' '}
                                            for the online portal *
                                        </label>
                                    </div>
                                    {touched.agreeTerms && errors.agreeTerms && (
                                        <p className="text-red-500 text-sm flex items-center ml-7">
                                            <AlertCircle className="w-4 h-4 mr-1" />
                                            {errors.agreeTerms}
                                        </p>
                                    )}

                                    <div className="flex items-start space-x-3">
                                        <input
                                            type="checkbox"
                                            id="declare"
                                            checked={values.declare}
                                            onChange={handleChange('declare')}
                                            onBlur={handleBlur('declare')}
                                            className="mt-1 w-4 h-4 text-green-600 border-gray-300 rounded focus:ring-green-500"
                                        />
                                        <label htmlFor="declare" className="text-sm text-gray-700">
                                            I declare that the information provided above is true and accurate to the best of my knowledge *
                                        </label>
                                    </div>
                                    {touched.declare && errors.declare && (
                                        <p className="text-red-500 text-sm flex items-center ml-7">
                                            <AlertCircle className="w-4 h-4 mr-1" />
                                            {errors.declare}
                                        </p>
                                    )}
                                </div>
                            </div>
                        )}



                        {/* Submit and Clear Buttons - Show for both forms */}
                        {values.isExistingCustomer && (
                            <div className="pt-6">
                                {isSubmitting ? (
                                    <div className="flex items-center justify-center py-4">
                                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600"></div>
                                        <span className="ml-3 text-green-600 font-medium">Sending application...</span>
                                    </div>
                                ) : (
                                    <div className="flex flex-col sm:flex-row gap-4">
                                        <button
                                            type="submit"
                                            className="flex-1 bg-gradient-to-r from-green-600 to-blue-600 text-white py-4 px-6 rounded-lg font-semibold text-lg hover:from-green-700 hover:to-blue-700 transform hover:scale-105 transition-all duration-200 shadow-lg flex items-center justify-center"
                                        >
                                            <Send className="w-5 h-5 mr-2" />
                                            Submit Application
                                        </button>
                                        <button
                                            type="button"
                                            onClick={clearForm}
                                            className="flex-1 sm:flex-none sm:px-8 bg-gray-500 text-white py-4 px-6 rounded-lg font-semibold text-lg hover:bg-gray-600 transform hover:scale-105 transition-all duration-200 shadow-lg"
                                        >
                                            Clear Form
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </div>
    );
}